import store from '../store'
import { startCase } from 'lodash'

export function formatGroupsAsCSV (headers, adGroups, groupBy) {
  const getMetricLookup = store.getters['MetricsModule/getMetricLookup']

  if (!Array.isArray(adGroups) || adGroups.length === 0) return null

  // handles snake case & capitalization
  const headersByKey = headers.map(header => header.key)

  const formattedGroupBy = startCase(groupBy)
  const groupHeaders = [
    formattedGroupBy,
    ...headersByKey.map(header => getMetricLookup?.[header]?.name || header)
  ]

  const headerKeys = [
    formattedGroupBy,
    ...headersByKey
  ]

  const csvLines = []

  csvLines.push(groupHeaders.join(','))

  // Iterate over headerKeys as it represents the order on the report
  for (let i = 0; i < adGroups.length; i++) {
    const row = adGroups[i]
    const flatRow = []

    for (let j = 0; j < headerKeys.length; j++) {
      let val
      if (headerKeys[j] === formattedGroupBy) {
        val = row.group_by
      } else {
        val = row[headerKeys[j]]
      }

      // Most likely not necessary, but here to handle any comma based values that could break the csv formatting
      if (typeof val === 'string' && (val.includes(',') || val.includes('"'))) {
        val = `"${val.replace(/"/g, '""')}"`
      }

      flatRow.push(val)
    }

    csvLines.push(flatRow.join(','))
  }

  return csvLines.join('\n')
}
